import React, { useState, useEffect, useContext } from "react";
import { PermissionService } from "../../../services/permission-service";
import { DataGrid } from "@material-ui/data-grid";
import { ToastContainer } from "react-toastify";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import AuthContext from "../../../context/auth-context";

export const Features = (props) => {
  const ctx = useContext(AuthContext);

  const accesslevelid = props.accesslevelid;

  const [accessmodules, setaccessmodules] = useState([]);
  const [defaultAccessModules, setdefaultAccessModules] = useState([]);

  const [userpermission, setuserPermission] = useState([]);

  const accessmodulesSearch = async () => {
    try {
      const result = await PermissionService.accessmodulesDetails();
      setdefaultAccessModules(result);

      defaultToTable();
    } catch (err) {
      //toast
      console.error(err);
    }
  };

  const defaultToTable = () => {
    let currentPerms = JSON.parse(JSON.stringify(defaultAccessModules));

    currentPerms = currentPerms.map((currentPermission) => {
      let defaultValues = [false, false, false, false];
      currentPermission.value_view = defaultValues[0];
      currentPermission.value_create = defaultValues[1];
      currentPermission.value_edit = defaultValues[2];
      currentPermission.value_delete = defaultValues[3];
      return currentPermission;
    });
    setaccessmodules(currentPerms);
  };

  const userpermissionSearch = async () => {
    try {

      const result = await PermissionService.userpermissionDetails(
        accesslevelid
      );

      setuserPermission(result);

      let userPermMap = {};
      result.forEach((userPermission) => {
        const moduleName = userPermission.access_module.module_name;
        const permissions = [
          userPermission.permission_view,
          userPermission.permission_add,
          userPermission.permission_edit,
          userPermission.permission_delete,
        ];
        userPermMap[moduleName] = permissions;
      });

      let currentPerms = JSON.parse(JSON.stringify(defaultAccessModules));
      currentPerms = currentPerms.map((currentPermission) => {
        let defaultValues = [false, false, false, false];
        if (userPermMap[currentPermission.module_name]) {
          defaultValues = userPermMap[currentPermission.module_name];
        }
     
        currentPermission.value_view = defaultValues[0];
        currentPermission.value_create = defaultValues[1];
        currentPermission.value_edit = defaultValues[2];
        currentPermission.value_delete = defaultValues[3];
        return currentPermission;
      });
      setaccessmodules(currentPerms);
    } catch (err) {
      //toast
      console.error(err);
    }
  };

  let permission_view = "";
  let permission_add = "";
  let permission_edit = "";
  let permission_delete = "";

  const createPermissions = async (e, params) => {
    if (params.field == "value_view") {
      permission_view = e;
      permission_add = params.row.value_create;
      permission_edit = params.row.value_edit;
      permission_delete = params.row.value_delete;
    } else if (params.field == "value_create") {
      permission_add = e;
      permission_view = params.row.value_view;
      permission_edit = params.row.value_edit;
      permission_delete = params.row.value_delete;
    } else if (params.field == "value_edit") {
      permission_edit = e;
      permission_view = params.row.value_view;
      permission_add = params.row.value_create;
      permission_delete = params.row.value_delete;
    } else if (params.field == "value_delete") {
      permission_delete = e;
      permission_view = params.row.value_view;
      permission_add = params.row.value_create;
      permission_edit = params.row.value_edit;
    } else {
    }

    try {
      await PermissionService.userpermissionCreate(
        accesslevelid,
        params.id,
        permission_view,
        permission_add,
        permission_edit,
        permission_delete
      );
      userpermissionSearch();

      notify("Permission successfully updated");
    } catch (err) {
      notifyWarning(err.response.data.message);

      //show error toast
    }
  };

  useEffect(() => {
    accessmodulesSearch();
  }, []);

  useEffect(() => {
    userpermissionSearch();
  }, [accesslevelid]);

  const columns = [
    {
      field: "module_name",
      headerName: "Module Name",
      flex: 5,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },

    {
      field: "value_view",
      headerName: "View",
      sortable: false,
      flex: 4,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      disableClickEventBubbling: true,
      renderCell: (params) => {
        return (
          <div className="mt-4">
            <label className="ms-switch">
              <input
                type="checkbox"
                checked={params.row.value_view}
                onChange={(e) => {
                  createPermissions(e.target.checked, params);
                }}
              />
              <span className="ms-switch-slider round" />
            </label>
          </div>
        );
      },
    },
    {
      field: "value_create",
      headerName: "Create",
      sortable: false,
      flex: 4,
      disableClickEventBubbling: true,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return (
          <div className="mt-4">
            <label className="ms-switch">
              <input
                type="checkbox"
                checked={params.row.value_create}
                onChange={(e) => createPermissions(e.target.checked, params)}
              />

              <span className="ms-switch-slider round" />
            </label>
          </div>
        );
      },
    },
    {
      field: "value_edit",
      headerName: "Edit",
      sortable: false,
      flex: 4,
      disableClickEventBubbling: true,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return (
          <div className="mt-4">
            <label className="ms-switch">
              <input
                type="checkbox"
                onChange={(e) => createPermissions(e.target.checked, params)}
                checked={params.row.value_edit}
              />
              <span className="ms-switch-slider round" />
            </label>
          </div>
        );
      },
    },
    {
      field: "value_delete",
      headerName: "Delete",
      sortable: false,
      flex: 4,
      disableClickEventBubbling: true,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return (
          <div className="mt-4">
            <label className="ms-switch">
              <input
                type="checkbox"
                onChange={(e) => createPermissions(e.target.checked, params)}
                checked={params.row.value_delete}
              />
              <span className="ms-switch-slider round" />
            </label>
          </div>
        );
      },
    },
  ];

  return (
    <div className="ms-content-wrapper">
      <div>
        <ToastContainer />
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="row">
            <div className="col-xl-12">
              <div className="ms-panel">
                <DataGrid
                  rows={accessmodules}
                  columns={columns}
                  pageSize={100}
                  pagination
                  // page={page}
                  hideFooter
                  autoHeight
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Features;
